module.exports = "<div class=\"form-button\">\r\n    <div dx-button=\"buttonOptions\"></div>\r\n</div>"